import { Component, Injectable } from '@angular/core';

export interface Toast { id: number; text: string; kind: 'ok' | 'err' | 'info'; }

@Injectable({ providedIn: 'root' })
export class ToastService {
  items: Toast[] = [];
  private seq = 0;
  ok(text: string) { this.push(text, 'ok'); }
  err(text: string) { this.push(text, 'err'); }
  info(text: string) { this.push(text, 'info'); }
  dismiss(id: number) { this.items = this.items.filter(t => t.id !== id); }
  private push(text: string, kind: Toast['kind']) {
    const id = ++this.seq;
    this.items = [...this.items, { id, text, kind }];
    setTimeout(() => this.dismiss(id), kind === 'err' ? 6000 : 3500);
  }
}

@Component({
  selector: 'app-toasts',
  template: `
    <div class="toasts">
      <div *ngFor="let t of toast.items" class="toast" [ngClass]="t.kind" (click)="toast.dismiss(t.id)">{{ t.text }}</div>
    </div>`
})
export class ToastsComponent {
  constructor(public toast: ToastService) {}
}
